var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 0.875H2.375C1.77826 0.875 1.20597 1.11205 0.78401 1.53401C0.362053 1.95597 0.125 2.52826 0.125 3.125V18.875C0.125 19.4717 0.362053 20.044 0.78401 20.466C1.20597 20.8879 1.77826 21.125 2.375 21.125H31.625C32.2217 21.125 32.794 20.8879 33.216 20.466C33.6379 20.044 33.875 19.4717 33.875 18.875V3.125C33.875 2.52826 33.6379 1.95597 33.216 1.53401C32.794 1.11205 32.2217 0.875 31.625 0.875ZM9.54688 18.875L2.375 12.7297V9.27031L9.54688 3.125H24.4531L31.625 9.27031V12.7297L24.4531 18.875H9.54688ZM22.625 11C22.625 12.1125 22.2951 13.2001 21.677 14.1251C21.0589 15.0501 20.1804 15.7711 19.1526 16.1968C18.1248 16.6226 16.9938 16.734 15.9026 16.5169C14.8115 16.2999 13.8092 15.7641 13.0225 14.9775C12.2359 14.1908 11.7001 13.1885 11.4831 12.0974C11.266 11.0062 11.3774 9.87524 11.8032 8.84741C12.2289 7.81957 12.9499 6.94107 13.8749 6.32298C14.7999 5.7049 15.8875 5.375 17 5.375C18.4918 5.375 19.9226 5.96763 20.9775 7.02252C22.0324 8.07742 22.625 9.50816 22.625 11Z",
    fill: "#026F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCod);
export default __webpack_public_path__ + "static/media/cod.b087b1dae5f2065a3a1cfbcefb906f16.svg";
export { ForwardRef as ReactComponent };